import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClose = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 10,
	height: 10,
	viewBox: "0 0 10 10",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#CAD5E3",
		fillRule: "nonzero",
		d: "M9.817 1.067a.625.625 0 1 0-.884-.884L5 4.116 1.067.183a.625.625 0 1 0-.884.884L4.116 5 .183 8.933a.625.625 0 0 0 .884.884L5 5.884l3.933 3.933a.625.625 0 1 0 .884-.884L5.884 5z"
	})
});
export default SvgClose;
